import React, {useState} from 'react';
import styles from './styles';
import {Loader} from '@xpertdox_js/xdcomponents';
import Message from './Message';

const MessageThread = props => {

  const {messages} = props;
  const [systemMessage, setSystemMessage] = useState(null);

  // set empty message after load(null messages value)
  if (messages === null && systemMessage === null) setSystemMessage(
    props.emptyMessage || 'There are no messages in this thread.'
  );


  return(
    <div style={styles.containerWrapper}>
      <div style={styles.topShadow} />
      <div style={styles.bottomShadow} />
      <div style={styles.container}>

      {messages === undefined && // show loader if mesages = undefined in state
        <Loader noBg/>
      }

      <div style={styles.messagesWrapper}>
        {messages && messages.map((msg, i) => // message list
          <Message
            key={msg._id}
            author={msg.from[0]}
            content={msg.content}
            timestamp={msg.createdAt}
            from={msg.from && (msg.from.includes(props.user.email) || msg.from.length === 0)}
          />
        )}
      </div>

      {systemMessage !== null && // message text to inform user of application status
        <div style={styles.systemMessageContainer}>
          <p style={styles.systemMessage}>{systemMessage}</p>
        </div>
      }
      </div>
    </div>
  );
}

export default MessageThread;
